import * as React from 'react';
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton } from 'office-ui-fabric-react';

type Props = {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

export const EstimatedChargeCalculationConfirmDialog: React.FC<Props> = (props) => {
    return (
        <Dialog
            minWidth={500}
            hidden={!props.isOpen}
            onDismiss={props.onCancel}
            dialogContentProps={{
                type: DialogType.normal,
                title: 'Change Estimated Charge Calculation?',
                subText: `Estimated Charge in the resource plan will be automatically re-calculated.
Are you sure you want to proceed with this change?`
            }}
            modalProps={{
                isBlocking: true
            }}
        >
            <DialogFooter>
                <DefaultButton onClick={props.onCancel} text="Cancel" />
                <PrimaryButton onClick={props.onConfirm} text="Proceed" />
            </DialogFooter>
        </Dialog>
    );
};
